import React from "react";
import { createRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Always createRoot, never hydrateRoot.
//
// index.html ships hand-written static HTML inside #root so crawlers see real
// content in the first response. That markup is not what React produces, so
// hydrateRoot fails with error #418, aborts, and leaves the static HTML on
// screen — the site looks unstyled and nothing works.
//
// createRoot replaces that markup cleanly. SEO is unaffected: crawlers read
// the HTML in the initial response, which is unchanged.

const container = document.getElementById("root");
container.innerHTML = "";

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);